
const Sitemap = () => {
  return (
    <div className="Body">Sitemap
    
    
    <ul>
  <li>
    <a href="/">Home</a>
  </li>
  <li>
    <a href="/about">About</a>
  </li>
  <li>
    <a href="/hire">Contact</a>
  </li>
  <li>
    <a href="/blog">Blog</a>
  </li>
  <li>
    <a href="/privacypolicy">Privacy Policy</a>
  </li>
  <li>
    <a href="/termsofservice">Terms of Service</a>
  </li>
</ul>

FAQ

<ul>
  <li>
    <a href="/faq/shipping">Shipping</a>
  </li>
  <li>
    <a href="/faq/returns">Returns</a>
  </li>
  <li>
    <a href="/faq/payment">Payment</a>
  </li>
</ul>
    
    </div>
  )
}

export default Sitemap